import styled, { css } from 'styled-components';
import { Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import { FiCheck as Check } from 'react-icons/fi';

import { ComponentProps } from './types';

export const Icon = styled(Check)`
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.6875rem;
`;

const StatusButton = styled.button<ComponentProps>`
  cursor: pointer;
  border-radius: 2rem;
  border: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  padding: 0 1.5rem;
  background-color: transparent;
  outline: none;

  ${({ variant, active }) => {
    switch (variant) {
      case active && 'complete':
        return css`
          cursor: default;
          background-color: ${({ theme }) => theme.colors.blueLight};
          border-color: ${({ theme }) => theme.colors.blueLight};
          color: ${({ theme }) => theme.colors.blueDark};
        `;
      case 'complete':
        return css`
          :focus,
          :hover:not(:disabled) {
            color: ${({ theme }) => theme.colors.blueDark};
          }
        `;
      case active && 'pending':
        return css`
          cursor: default;
          background-color: ${({ theme }) => theme.colors.yellowLight};
          border-color: ${({ theme }) => theme.colors.yellowLight};
          color: ${({ theme }) => theme.colors.yellowDark};
        `;
      case 'pending':
        return css`
          :focus,
          :hover:not(:disabled) {
            color: ${({ theme }) => theme.colors.yellowDark};
          }
        `;
      case active && 'ready':
        return css`
          cursor: default;
          background-color: ${({ theme }) => theme.colors.greenExtraLight};
          border-color: ${({ theme }) => theme.colors.greenExtraLight};
          color: ${({ theme }) => theme.colors.greenDark};
        `;
      case 'ready':
        return css`
          :focus,
          :hover:not(:disabled) {
            color: ${({ theme }) => theme.colors.greenDark};
          }
        `;

      case 'cancelled':
        return css`
          background-color: ${({ theme }) => theme.colors.redExtraLight};
          border-color: ${({ theme }) => theme.colors.redExtraLight};
          color: ${({ theme }) => theme.colors.redDark};
          cursor: default;
        `;

      default:
      case 'scheduled':
        return css`
          background-color: ${({ theme }) => theme.colors.navyGreenLight};
          border-color: ${({ theme }) => theme.colors.navyGreenLight};
          color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
          cursor: default;
        `;
    }
  }}
`;

export const Caption = styled(Body)``;

export default StatusButton;
